import { combineReducers } from '@reduxjs/toolkit';
import { videoDashboardReducer } from './dashboard';
import { videoManagementReducer } from './management';

export const videoReducer = combineReducers({
  dashboard: videoDashboardReducer,
  management: videoManagementReducer
});
